import { render, staticRenderFns } from "./one_year.vue?vue&type=template&id=98cc98d2&scoped=true&"
import script from "./one_year.vue?vue&type=script&lang=js&"
export * from "./one_year.vue?vue&type=script&lang=js&"
import style0 from "./one_year.vue?vue&type=style&index=0&id=98cc98d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cc98d2",
  null
  
)

export default component.exports